<!--
  作者：顾先生
-->
<template>
  <div id="kefu">
    <img src="../assets/zhishi327/kefu.png" class="kefu_img" @click="weiZixun">
    <img src="../assets/zhishi327/dianhua.png" class="kefu_img" @click="boZixun">
  </div>
</template>

<script>
export default {
  name: 'kefu',
  // 注册组件
  components: {},
  // 注册方法
  methods: {
    // 拨打客服电话
    boZixun () {
      window.location.href = 'tel://15075266990'
    },
    // 微信客服
    weiZixun () {
      window.location.href = 'https://work.weixin.qq.com/kfid/kfc2f7ba12adb97363c'
    }
  },
  // 父子传值
  props: {},
  // 数据渲染
  data () {
    return {

    }
  },
  // 计算属性
  computed: {},
  // 监听器
  watch: {},
  // 页面初次解析完成
  created () {},
  // 页面内容渲染完成
  mounted () {}
}
</script>

<style scoped lang="less">
.kefu_img{
  margin-top: 10px;
  display: flex;
  width:55px;
  height:55px;
}
</style>
